import qs from "qs";
import {
  CreateOrderRequest,
  OrderItemMappingRequest,
  OrderReportResponse,
  OrderResponse,
  RevenueResponse,
  TopSaleCupResponse,
  UpdateOrderRequest,
} from "../model/OrderModel";
import { GROUP_BY_ENUM, ORDER_STATUS_ENUM } from "../../applications/constants/AppConst";
import { PageResponse } from "../../applications/constants/AppTypes";
import { ApiClient } from "../api/ApiClient";

const BASE_URL = "/api/orders";
class OrderServiceClass {
  getAllOrders(
    page: number,
    limit: number,
    status: ORDER_STATUS_ENUM[],
    startDate?: number,
    endDate?: number
  ) {
    return ApiClient.get<PageResponse<OrderResponse[]>>(BASE_URL + "/all", {
      params: {
        page,
        limit,
        status,
        startDate,
        endDate,
      },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    });
  }

  getRevenue(
    page: number,
    limit: number,
    status: ORDER_STATUS_ENUM[],
    startDate?: number,
    endDate?: number
  ) {
    return ApiClient.get<RevenueResponse>(BASE_URL + "/revenue", {
      params: {
        page,
        limit,
        status,
        startDate,
        endDate,
      },
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    });
  }

  getOrderReport(startDate?: number, endDate?: number, groupBy?: GROUP_BY_ENUM) {
    return ApiClient.get<OrderReportResponse[]>(BASE_URL + "/report", {
      params: {
        startDate,
        endDate,
        groupBy,
      },
    });
  }

  getTopHotSaleCup(startDate?: number, endDate?: number) {
    return ApiClient.get<TopSaleCupResponse[]>(BASE_URL + "/report/top_cup", {
      params: {
        startDate,
        endDate,
      },
    });
  }

  getItemsInOrder(orderId: number) {
    return ApiClient.get<OrderItemMappingRequest[]>(BASE_URL + `/${orderId}/items`);
  }

  createNewOrder(request: CreateOrderRequest) {
    return ApiClient.post<OrderResponse>(BASE_URL + "/create", request);
  }

  updateOrder(id: number, request: CreateOrderRequest) {
    return ApiClient.put<OrderResponse>(BASE_URL + `/update-order/${id}`, request);
  }

  updateOrderStatusAndUserInfo(
    orderId: number,
    newStatus: ORDER_STATUS_ENUM,
    name?: string,
    phone?: string,
    address?: string
  ) {
    return ApiClient.put(BASE_URL + `/update-status/${orderId}`, {
      status: newStatus,
      name: name || "",
      phone: phone || "",
      address: address || "",
    });
  }

  deleteOrder(orderId: number, password: string) {
    return ApiClient.post(BASE_URL + `/delete`, {
      order_id: orderId,
      password: btoa(password),
    });
  }

  returnOrder(orderId: number, password: string) {
    return ApiClient.post(BASE_URL + `/return`, {
      order_id: orderId,
      password: btoa(password),
    });
  }

  updateOrderCounterDiscount(request: UpdateOrderRequest) {
    return ApiClient.put(BASE_URL + `/update-counter-discount`, request);
  }
}

export const OrderService = new OrderServiceClass();
